import styled from 'styled-components'
import Note from 'components/Note'

const ThickNote = styled(Note)`
  font-family: ${props => props.theme.font.boldFamily};
`

export default ThickNote
